module.exports = __webpack_public_path__ + "static/media/info-blue.92640dc5.svg";